
export default {
  name: "PostOverview",
  props: {
    posts: Array,
  },
}
